import type { components } from '@joyful/openapi/types.gen'

type PracticeRequestDisplayFields = Pick<
  components['schemas']['PracticeRequestRead'],
  'description' | 'title'
>

const MENTION_MARKDOWN_PATTERN =
  /\[((?:\\.|[^\]])*)\]\((carc|cpt|encounter|enrichment_status|kpi_email|message|modifier|patient|phone_call|practice_request|project|skill|user|workflow_status):[^\s)]+\)/gi

const PURPOSE_OF_ASK_HEADING_PATTERN = /\*\*Purpose of ask:\*\*|Purpose of ask:/

export function stripMentionMarkdownToDisplayText(text: string): string {
  return text.replace(
    MENTION_MARKDOWN_PATTERN,
    (_match, displayText: string) => {
      return displayText
        .replaceAll(String.raw`\]`, ']')
        .replaceAll(String.raw`\[`, '[')
        .replaceAll(String.raw`\\`, '\\')
    },
  )
}

export function formatPracticeRequestDescriptionMarkdown(description: string) {
  const headingMatch = description.match(PURPOSE_OF_ASK_HEADING_PATTERN)
  const headingIndex = headingMatch?.index
  if (!headingIndex) {
    return description
  }

  const beforeHeading = description.slice(0, headingIndex)
  const fromHeading = description.slice(headingIndex)
  if (/\n\s*\n\s*$/.test(beforeHeading)) {
    return description
  }

  const trimmedBeforeHeading = beforeHeading.replace(/\s+$/, '')
  return `${trimmedBeforeHeading}\n\n${fromHeading}`
}

export function getPracticeRequestDisplayText(
  practiceRequest: PracticeRequestDisplayFields,
) {
  const title = practiceRequest.title?.trim()
  const description = practiceRequest.description?.trim()
  const plainTitle =
    title === undefined || title.length === 0
      ? undefined
      : stripMentionMarkdownToDisplayText(title)
  const plainDescription =
    description === undefined || description.length === 0
      ? undefined
      : stripMentionMarkdownToDisplayText(description)
  const secondaryText =
    plainTitle && plainTitle !== plainDescription
      ? (plainDescription ?? '')
      : ''

  return {
    primaryText: plainTitle || plainDescription || '(no description)',
    secondaryText,
    source: title ? 'title' : description ? 'description' : 'placeholder',
  }
}
